// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-dot.js';

import { paths } from '../generated/circle-dot';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-dot', Original, paths);
